// filepath: apps/web/src/features/directory/employment-timeline/EmploymentTimelineRoute.tsx
//
// FR-UI-DIR-1 AC-5 — route shell for /employment/:personId.

import React from "react";
import { EmploymentTimelinePage } from "./EmploymentTimelinePage";

export interface EmploymentTimelineRouteProps {
  personId: string;
}

export function EmploymentTimelineRoute({
  personId,
}: EmploymentTimelineRouteProps): React.ReactElement {
  return <EmploymentTimelinePage personId={personId} />;
}
